import axios from 'axios';
import { apiInstance } from './client';

function getToken() {
  const token = document.cookie.match('(^|;) ?token=([^;]*)(;|$)');
  return token ? token[2] : null;
}

// Access Token 발급
function login(email, password) {
  if (!getToken()) {
    return apiInstance
      .post('/v1/auth/token', {
        email: email,
        password: password,
      })
      .then((response) => {
        //token with cookie
        const token = response.data.token;
        const date = new Date();
        date.setTime(date.getTime() + 1000 * 60 * 60);
        document.cookie = 'token=' + token + ';expires=' + date.toUTCString() + ';path=/';

        return response;
      })
      .catch((error) => {
        return error.response;
      });
  } else {
    return getToken();
  }
}

// 회원가입
function enroll(email, password, name) {
  return apiInstance.post('/v1/auth/signup', {
    name: name,
    password: password,
    email: email,
  });
}

// 동료 평가지 생성
function postPaperData(data) {
  const token = getToken();

  return apiInstance.post('/v1/evaluation-papers', data, {
    headers: {
      authorization: token,
    },
  });
}

// 동료 평가지 전송
function sendPaperToEmail(id) {
  const token = getToken();

  return apiInstance.post(`/v1/evaluation-papers/${id}/email`, null, {
    headers: {
      authorization: token,
    },
  });
}

// 동료 평가지 조회
function getPaperData2() {
  return apiInstance.get('/v1/evaluation-papers', {
    headers: {
      // authorization: token,
      'Content-Type': 'multipart/form-datas;',
    },
  });
}

function getPaperData() {
  return apiInstance({
    url: '/v1/evaluation-papers',
    method: 'get',
    headers: {
      // authorization: token,
      'Content-Type': 'multipart/form-datas;',
    },
  });
}

// 동료 평가지 상세 조회
function getPaperDetailData(evaluationPaperId) {
  const token = getToken();

  return apiInstance.get(`/v1/evaluation-papers/${evaluationPaperId}`, {
    headers: {
      authorization: token,
    },
  });
}

// 학생 평가지 조회
function getStudentEvaluation(evaluationPaperId, studentId) {
  return apiInstance.get(
    `/v1/evaluation-papers/${evaluationPaperId}/students/${studentId}/reviews`
  );
}

// 학생 평가지 저장
function putStudentEvaluation(data, evaluationPaperId, studentId) {
  return apiInstance.put(
    `/v1/evaluation-papers/${evaluationPaperId}/students/${studentId}/reviews`,
    data
  );
}

export {
  login,
  enroll,
  postPaperData,
  sendPaperToEmail,
  getPaperData,
  getPaperDetailData,
  getStudentEvaluation,
  putStudentEvaluation,
};
